import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Row, Col, Button } from 'reactstrap';
import CustomControl from '../../../../components/CustomControl/CustomControl';

const StatisticsConversionsTableSettings = ({ saveSettings, toggleSettingsModal, fieldConfig }) => {
  const [fields, setFields] = useState([]);
  useEffect(() => {
    setFields(
      fieldConfig.map(field => ({ id: field.id, checked: field.isRendering, title: field.title })),
    );
  }, [fieldConfig]);

  const handleChooseEvery = () => {
    const updatedFields = [...fields];
    updatedFields.map(field => {
      field['checked'] = true;
      return field;
    });
    setFields(updatedFields);
  };
  const handleRemoveSelections = () => {
    const updatedFields = [...fields];
    updatedFields.map(field => {
      if (field.id === 126) {
        field['checked'] = true;
      } else {
        field['checked'] = false;
      }
      return field;
    });
    setFields(updatedFields);
  };
  const handleChange = ({ target }) => {
    const { value } = target;
    const updatedFields = [...fields];
    updatedFields.map(field => {
      if (field.id === Number(value)) {
        const bool = !field.checked;
        field['checked'] = bool;
      }
      return field;
    });
    setFields(updatedFields);
  };
  const saveBtnHandler = () => {
    saveSettings(fields);
    toggleSettingsModal();
  };
  return (
    <Row>
      {fields.map(
        field =>
          field.id > 0 && (
            <Col lg="4" key={field.id}>
              <Col lg="12">
                <CustomControl
                  id={`table-field-${field.id}`}
                  name={`${field.id}`}
                  value={field.id}
                  className="custom-control-xs no-margin"
                  onChange={handleChange}
                  checked={field.checked}
                  label={
                    <FormattedMessage
                      id={`statistics.table.conversions.title.${field.title}`}
                      defaultMessage={field.title}
                    />
                  }
                  inline
                />
              </Col>
            </Col>
          ),
      )}

      <Col lg={{ size: 7, offset: 5 }} className="logs-settings-buttons">
        <Button onClick={handleRemoveSelections} color="primary" outline size="sm">
          <FormattedMessage id="main.removeSelections" defaultMessage="Remove selections" />
        </Button>
        <Button onClick={handleChooseEvery} color="primary" outline size="sm">
          <FormattedMessage id="main.selectAll" defaultMessage="Select all" />
        </Button>
        <Button onClick={saveBtnHandler} mr="1" color="primary" size="sm">
          <FormattedMessage id="main.save" defaultMessage="Save" />
        </Button>
      </Col>
    </Row>
  );
};

export default StatisticsConversionsTableSettings;
